module.exports = __webpack_public_path__ + "static/media/kmd.5ad4630c.svg";